import { Stack } from '@fluentui/react';
import { mergeClasses, Text } from '@fluentui/react-components';
import { FC, ReactNode } from 'react';

const MessageScreen: FC<{ className?: string; message: string; icon: ReactNode }> = ({ className, icon, message }) => (
	<Stack className={mergeClasses('stackPanel', className)}>
		<Stack.Item>{icon}</Stack.Item>
		<Stack.Item>
			<Text size={400} weight={'medium'}>
				{message}
			</Text>
		</Stack.Item>
	</Stack>
);

export default MessageScreen;
